var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("rect", { width: "40", height: "40", fill: "#E1F7F7", rx: "8" }),
      React.createElement("path", { d: "M8 8h24v24H8z" }),
      React.createElement("path", { fill: "#018489", d: "M27.142 13.464a5 5 0 0 0-7.705 6.298l-.073.066-7.071 7.071a1 1 0 0 0 1.327 1.492l.087-.077 1.414-1.415 1.415 1.415a1 1 0 0 0 1.327.077l.087-.077a1 1 0 0 0 .077-1.327l-.077-.088-1.414-1.414 1.414-1.414 1.414 1.414a1 1 0 0 0 1.327.078l.087-.078a1 1 0 0 0 .078-1.327l-.078-.087-1.414-1.414 1.414-1.414c.024-.024.047-.05.068-.075a5 5 0 0 0 6.296-7.703zm-1.414 1.415a3 3 0 1 1-4.243 4.242 3 3 0 0 1 4.243-4.242z" })
    )
  );
});